import EmblaCarousel, {
  type EmblaCarouselType,
  type EmblaPluginType,
} from 'embla-carousel';
import EmblaClassNames from 'embla-carousel-class-names';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';

interface CarouselOptions {
  navDots?: boolean;
  controlButtons?: boolean;
}

const initControlButtons = (carouselId: string, embla: EmblaCarouselType) => {
  const prevButtonNode = document.querySelector<HTMLButtonElement>(
    `.embla__prev[data-uuid="${carouselId}"]`,
  );

  const nextButtonNode = document.querySelector<HTMLButtonElement>(
    `.embla__next[data-uuid="${carouselId}"]`,
  );

  prevButtonNode?.addEventListener('click', () => embla.scrollPrev(), false);
  nextButtonNode?.addEventListener('click', () => embla.scrollNext(), false);
};

const addDotBtnsAndClickHandlers = (
  dotContainerEl: HTMLElement,
  emblaApi: EmblaCarouselType,
) => {
  let dotEls: HTMLElement[] = [];

  const addDotBtnsWithClickHandlers = () => {
    dotContainerEl.innerHTML = emblaApi
      .scrollSnapList()
      .map(
        () =>
          '<button class="embla__dot appearance-none" type="button"></button>',
      )
      .join('');

    const scrollTo = (index: number) => {
      emblaApi.scrollTo(index);
    };

    dotEls = Array.from(dotContainerEl.querySelectorAll('.embla__dot'));
    dotEls.forEach((dotNode, index) => {
      dotNode.addEventListener('click', () => scrollTo(index), false);
    });
  };

  const toggleDotBtnsActive = () => {
    const previous = emblaApi.previousScrollSnap();
    const selected = emblaApi.selectedScrollSnap();
    dotEls[previous]?.classList.remove('embla__dot--selected');
    dotEls[selected]?.classList.add('embla__dot--selected');
  };

  emblaApi
    .on('init', addDotBtnsWithClickHandlers)
    .on('reInit', addDotBtnsWithClickHandlers)
    .on('init', toggleDotBtnsActive)
    .on('reInit', toggleDotBtnsActive)
    .on('select', toggleDotBtnsActive);

  return () => {
    dotContainerEl.innerHTML = '';
  };
};

export const initCarousel = ({ navDots, controlButtons }: CarouselOptions) => {
  // Get all carousels on the page
  const carouselEls = document.querySelectorAll<HTMLElement>('.embla');

  // Initialize each carousel
  for (const carouselEl of carouselEls) {
    const carouselId = carouselEl.dataset.uuid;
    const viewportEl =
      carouselEl.querySelector<HTMLElement>('.embla__viewport');
    const dotsContainerEl =
      carouselEl.querySelector<HTMLElement>(`.embla__dots`);

    const carouselOptions = JSON.parse(
      carouselEl.dataset.carouselOptions || '{}',
    );

    if (!viewportEl) continue;

    const embla = EmblaCarousel(viewportEl, carouselOptions, [
      EmblaClassNames(),
      WheelGesturesPlugin() as unknown as EmblaPluginType,
    ]);

    if (controlButtons && carouselId) {
      initControlButtons(carouselId, embla);
    }

    if (navDots && dotsContainerEl) {
      addDotBtnsAndClickHandlers(dotsContainerEl, embla);
    }
  }
};
